<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 1671 1114">
  <g>
    <g id="Layer_1">
      <g>
        <g id="BG">
          <rect class="cls-5" width="1671" height="1114" [ngStyle]="getStyle(backgroundColor)" />
        </g>
        <g id="Layer_1-2" data-name="Layer_1">
          <circle class="cls-11" cx="301.3" cy="911.4" r="87.9" [ngStyle]="getStyle(primaryColor)" />
          <g class="cls-8">
            <g class="cls-8" [ngStyle]="getStyle(numberColor)">
              <path
                d="M279.2,938.8h16.1v-46.2c0-1.8,0-3.7.2-5.6l-11.4,9.5c-.5.4-1,.7-1.5.8-.5.1-1,.2-1.5.2-.7,0-1.4-.2-2-.5-.6-.3-1.1-.7-1.3-1.1l-4.3-5.9,24.2-20.5h11.1v69.2h14.2v10.1h-43.8v-10.1Z"
              />
            </g>
          </g>
          <g>
            <path
              class="cls-13"
              d="M469.3,147.3v586.5c0,19.7-16,35.7-35.7,35.7H169c-19.7,0-35.7-16-35.7-35.7V147.3c0-19.7,16-35.7,35.7-35.7h264.6c19.7,0,35.7,16,35.7,35.7h0Z"
            />
            <rect
              class="cls-5"
              x="143.3"
              y="121.6"
              width="316"
              height="637.9"
              rx="25.7"
              ry="25.7"
              [ngStyle]="getStyle(backgroundColor)"
            />
            <rect class="cls-11" x="178.3" y="427.3" width="251.8" height="269" [ngStyle]="getStyle(primaryColor)" />
            <g id="Q8hSlu">
              <g [ngStyle]="getStyle(qrCodeColor)">
                <path class="cls-10" d="M221,458h59.4v59.4h-59.4v-59.4h0ZM232.9,505.5h35.6v-35.6h-35.6v35.6Z" />
                <path class="cls-10" d="M328.1,458h59.4v59.4h-59.4v-59.4h0ZM375.6,505.5v-35.6h-35.6v35.6h35.6Z" />
                <path class="cls-10" d="M221,624.5v-59.4h59.4v59.4h-59.4ZM268.5,612.6v-35.6h-35.6v35.6h35.6Z" />
                <path
                  class="cls-10"
                  d="M375.6,588.8v11.9h-23.8v-23.8h-23.8v-11.9h35.7v-23.8h11.9v-11.9h11.9v23.7h-11.9v23.9h-11.8v11.9h11.8,0Z"
                />
                <path
                  class="cls-10"
                  d="M304.3,529.3h-11.9v-23.7h11.7v-11.9h-11.7v-35.7h23.6v11.8h-11.7v11.9h11.7v35.7h-11.8v11.9h0Z"
                />
                <path class="cls-10" d="M304.2,541.2v23.8h-11.9v-11.8h-35.7v-11.9h-11.9v-11.9h23.7v11.8h35.8Z" />
                <path class="cls-10" d="M351.8,600.7v23.7h-47.6v-11.8h35.7v-11.9h11.9Z" />
                <path class="cls-10" d="M304.3,612.6h-11.8v-35.7h11.8v11.9h11.9v12h-11.9v11.9h0Z" />
                <path class="cls-10" d="M351.8,529.4v23.7h-11.8v-11.8h-11.9v-11.8h23.7,0Z" />
                <path class="cls-10" d="M304.3,577v-12h11.9v11.9h-11.9Z" />
                <path class="cls-10" d="M316.2,565v-11.8h11.9v11.8h-11.9Z" />
                <path class="cls-10" d="M232.8,541.2h12v11.8h-11.9v-11.8h-.1Z" />
                <path class="cls-10" d="M304.3,541.2v-12h11.8v11.9h-11.8Z" />
                <path class="cls-10" d="M375.6,576.9h11.8v11.9h-11.8v-11.9h0Z" />
                <path class="cls-10" d="M232.9,541.2h-11.8v-11.8h11.8v11.8h0Z" />
                <path class="cls-10" d="M375.6,600.8h11.8v11.9h-11.8v-11.9h0Z" />
                <path class="cls-10" d="M375.7,612.6v11.8h-11.8v-11.8h11.8Z" />
                <path class="cls-10" d="M244.8,481.8h11.7v11.7h-11.7v-11.7Z" />
                <path class="cls-10" d="M363.7,493.6h-11.8v-11.7h11.8v11.7Z" />
                <path class="cls-10" d="M244.8,600.7v-11.7h11.8v11.7h-11.8Z" />
                <path class="cls-10" d="M316.1,588.9v-11.9h11.9v11.9h-11.9Z" />
                <path class="cls-10" d="M340,600.8h-11.9v-11.9h11.9v11.9Z" />
              </g>
            </g>
            <path
              class="cls-6"
              d="M218.6,646.8h117.4c2.2,0,4,1.8,4,4h0c0,2.2-1.8,4-4,4h-117.4c-2.2,0-4-1.8-4-4h0c0-2.2,1.8-4,4-4Z"
            />
            <path
              class="cls-6"
              d="M218.6,661.8h167.7c2.2,0,4,1.8,4,4h0c0,2.2-1.8,4-4,4h-167.7c-2.2,0-4-1.8-4-4h0c0-2.2,1.8-4,4-4Z"
            />
            <path
              class="cls-7"
              d="M209.4,257.2h133.2c2.2,0,4,1.8,4,4h0c0,2.2-1.8,4-4,4h-133.2c-2.2,0-4-1.8-4-4h0c0-2.2,1.8-4,4-4Z"
            />
            <path
              class="cls-7"
              d="M209.4,272.2h189.7c2.2,0,4,1.8,4,4h0c0,2.2-1.8,4-4,4h-189.7c-2.2,0-4-1.8-4-4h0c0-2.2,1.8-4,4-4Z"
            />
            <path
              class="cls-7"
              d="M209.4,287.1h189.7c2.2,0,4,1.8,4,4h0c0,2.2-1.8,4-4,4h-189.7c-2.2,0-4-1.8-4-4h0c0-2.2,1.8-4,4-4Z"
            />
            <path
              class="cls-7"
              d="M209.4,302.1h189.7c2.2,0,4,1.8,4,4h0c0,2.2-1.8,4-4,4h-189.7c-2.2,0-4-1.8-4-4h0c0-2.2,1.8-4,4-4Z"
            />
            <rect class="cls-11" x="178.3" y="164.4" width="251.8" height="63.7" [ngStyle]="getStyle(primaryColor)" />
            <rect class="cls-11" x="256.6" y="347" width="95.4" height="36.1" [ngStyle]="getStyle(primaryColor)" />
          </g>
          <g>
            <rect
              class="cls-13"
              x="658.7"
              y="72.6"
              width="307.4"
              height="602"
              rx="32.7"
              ry="32.7"
              transform="translate(-72 241.5) rotate(-16.2)"
            />
            <rect
              class="cls-5"
              x="668.1"
              y="82.1"
              width="289.1"
              height="583.7"
              rx="23.5"
              ry="23.5"
              transform="translate(-72.1 241.6) rotate(-16.2)"
              [ngStyle]="getStyle(backgroundColor)"
            />
            <rect
              class="cls-11"
              x="731.1"
              y="356.7"
              width="230.5"
              height="246.1"
              transform="translate(-100.2 255.2) rotate(-16.2)"
              [ngStyle]="getStyle(primaryColor)"
            />
            <g id="Q8hSlu-2">
              <g [ngStyle]="getStyle(qrCodeColor)">
                <path
                  class="cls-10"
                  d="M746.7,409.4c17.4-5.1,34.8-10.1,52.2-15.2,5.1,17.4,10.1,34.7,15.2,52.2-17.3,5-34.7,10.1-52.2,15.2-5-17.3-10.1-34.7-15.2-52.2ZM769.3,448.1c10.5-3.1,20.9-6.1,31.3-9.1-3-10.5-6.1-20.8-9.1-31.2-10.5,3-20.9,6.1-31.3,9.1l9.1,31.2Z"
                />
                <path
                  class="cls-10"
                  d="M840.9,382c17.4-5.1,34.8-10.1,52.2-15.2,5.1,17.4,10.1,34.7,15.2,52.2-17.3,5-34.7,10.1-52.2,15.2-5-17.3-10.1-34.7-15.2-52.2ZM894.7,411.6c-3-10.5-6.1-20.9-9.1-31.2l-31.2,9.1c3,10.5,6.1,20.8,9.1,31.2,10.4-3,20.8-6,31.2-9.1Z"
                />
                <path
                  class="cls-10"
                  d="M789.3,555.7c-5.1-17.4-10.1-34.8-15.2-52.2,17.4-5.1,34.7-10.1,52.2-15.2,5,17.3,10.1,34.7,15.2,52.2-17.3,5-34.7,10.1-52.2,15.2ZM827.9,533.1c-3-10.5-6.1-20.9-9.1-31.2-10.5,3-20.9,6.1-31.2,9.1,3,10.5,6.1,20.8,9.1,31.2,10.4-3,20.8-6.1,31.2-9.1Z"
                />
                <path
                  class="cls-10"
                  d="M916,484.9l3,10.5h0c-7,2-14,4-20.9,6.1h0c-2-6.9-4-13.9-6.1-20.9l-20.9,6.1-3-10.5h0c10.4-3,20.8-6,31.4-9.1-2-7-4-13.9-6.1-20.9l10.4-3c-1-3.5-2-6.9-3-10.4l10.5-3,6,20.8-10.4,3,6.1,21h0c-3.5,1-6.9,2-10.4,3l3.1,10.5c3.5-1,7-2,10.4-3h0v-.2Z"
                />
                <path
                  class="cls-10"
                  d="M838.1,450.8c-3.4,1-6.9,2-10.4,3-2-6.9-4-13.8-6.1-20.8l10.3-3-3-10.4-10.3,3c-3.1-10.5-6.1-20.9-9.1-31.4l20.8-6,3,10.4-10.3,3c1,3.5,2,6.9,3,10.4,3.4-1,6.8-2,10.3-3,3.1,10.5,6.1,20.9,9.1,31.4l-10.4,3,3,10.5h.1Z"
                />
                <path
                  class="cls-10"
                  d="M841.1,461.3c2,7,4.1,13.9,6.1,20.9h0l-10.5,3-3-10.4c-10.5,3.1-20.9,6.1-31.4,9.1l-3-10.5-10.5,3h0c-1-3.4-2-6.9-3-10.4,6.9-2,13.8-4,20.8-6.1l3,10.4c10.6-3.1,21-6.1,31.4-9.1h.1Z"
                />
                <path
                  class="cls-10"
                  d="M898.2,501.4c2,6.9,4,13.9,6.1,20.9-13.9,4.1-27.8,8.1-41.8,12.2l-3-10.4h0c10.4-3,20.9-6,31.4-9.1-1-3.6-2.1-7-3.1-10.5l10.5-3h-.1Z"
                />
                <path
                  class="cls-10"
                  d="M859.4,524l-10.4,3c-3-10.4-6.1-20.8-9.1-31.3l10.4-3h0c1,3.4,2,6.9,3,10.4,3.6-1,7-2.1,10.5-3.1l3.1,10.5-10.5,3.1,3,10.4h0Z"
                />
                <path
                  class="cls-10"
                  d="M879.9,438.8c2,7,4,13.8,6,20.8l-10.4,3c-1-3.4-2-6.8-3-10.4l-10.4,3-3-10.4c6.9-2,13.8-4,20.8-6.1h0Z"
                />
                <path class="cls-10" d="M850.3,492.7l-3-10.5h0l10.5-3h0c1,3.5,2.1,7,3.1,10.5l-10.5,3h0Z" />
                <path class="cls-10" d="M857.7,479.2l-3-10.4,10.4-3c1,3.5,2,6.9,3,10.4h0c-3.5,1-7,2-10.5,3.1h0Z" />
                <path class="cls-10" d="M778.4,479.6l10.5-3h0c1,3.4,2,6.9,3,10.4l-10.5,3c-1-3.5-2-6.9-3-10.4h0Z" />
                <path class="cls-10" d="M841.2,461.3l-3-10.5h0c3.4-1,6.9-2,10.4-3l3,10.5c-3.5,1-6.9,2-10.4,3h0Z" />
                <path
                  class="cls-10"
                  d="M913,474.4c3.4-1,6.9-2,10.4-3,1,3.5,2,6.9,3,10.4-3.5,1-6.9,2-10.4,3h0c-1-3.5-2-7-3.1-10.5h0Z"
                />
                <path class="cls-10" d="M778.4,479.5l-10.4,3-3-10.4c3.4-1,6.8-2,10.4-3,1,3.5,2,6.9,3,10.4h0Z" />
                <path class="cls-10" d="M919.1,495.3c3.4-1,6.9-2,10.4-3l3,10.4-10.4,3h0c-1-3.5-2-7-3.1-10.5h0Z" />
                <path class="cls-10" d="M922.1,505.8c1,3.4,2,6.9,3,10.4l-10.4,3-3-10.4c3.5-1,6.9-2,10.4-3h0Z" />
                <path class="cls-10" d="M773.7,424.3l10.3-3,3,10.3-10.3,3-3-10.3Z" />
                <path class="cls-10" d="M881.2,404.2l-10.3,3c-1-3.4-2-6.8-3-10.3l10.3-3,3,10.3Z" />
                <path class="cls-10" d="M804.1,528.7l-3-10.3c3.4-1,6.8-2,10.3-3l3,10.3c-3.4,1-6.9,2-10.3,3Z" />
                <path class="cls-10" d="M863.8,500.1l-3.1-10.5c3.5-1,7-2,10.5-3.1l3.1,10.5-10.5,3.1Z" />
                <path class="cls-10" d="M887.8,504.5l-10.5,3.1-3.1-10.5,10.5-3.1,3.1,10.5Z" />
              </g>
            </g>
            <path
              class="cls-6"
              d="M792.7,576.4l103.1-30c2-.6,4,.6,4.6,2.5h0c.6,2-.6,4-2.5,4.6l-103.1,30c-2,.6-4-.6-4.6-2.5h0c-.6-2,.6-4,2.5-4.6Z"
            />
            <path
              class="cls-6"
              d="M796.6,589.5l147.2-42.8c2-.6,4,.6,4.6,2.5h0c.6,2-.6,4-2.5,4.6l-147.2,42.8c-2,.6-4-.6-4.6-2.5h0c-.6-2,.6-4,2.5-4.6Z"
            />
            <path
              class="cls-7"
              d="M685.3,236.2l117-34c2-.6,4,.6,4.6,2.5h0c.6,2-.6,4-2.5,4.6l-117,34c-2,.6-4-.6-4.6-2.5h0c-.6-2,.6-4,2.5-4.6Z"
            />
            <path
              class="cls-7"
              d="M689.1,249.4l166.6-48.4c2-.6,4,.6,4.6,2.5h0c.6,2-.6,4-2.5,4.6l-166.6,48.4c-2,.6-4-.6-4.6-2.5h0c-.6-2,.6-4,2.5-4.6Z"
            />
            <path
              class="cls-7"
              d="M693,262.6l166.6-48.4c2-.6,4,.6,4.6,2.5h0c.6,2-.6,4-2.5,4.6l-166.6,48.4c-2,.6-4-.6-4.6-2.5h0c-.6-2,.6-4,2.5-4.6Z"
            />
            <path
              class="cls-7"
              d="M696.7,275.8l166.6-48.4c2-.6,4,.6,4.6,2.5h0c.6,2-.6,4-2.5,4.6l-166.6,48.4c-2,.6-4-.6-4.6-2.5h0c-.6-2,.6-4,2.5-4.6Z"
            />
            <rect
              class="cls-11"
              x="637.7"
              y="129.5"
              width="230.5"
              height="58.2"
              transform="translate(-14.3 216.4) rotate(-16.2)"
              [ngStyle]="getStyle(primaryColor)"
            />
            <rect
              class="cls-11"
              x="752.5"
              y="290.3"
              width="87.3"
              height="33"
              transform="translate(-54 234.3) rotate(-16.2)"
              [ngStyle]="getStyle(primaryColor)"
            />
          </g>
          <g>
            <circle class="cls-11" cx="835.5" cy="911.4" r="87.9" [ngStyle]="getStyle(primaryColor)" />
            <g class="cls-8">
              <g class="cls-8" [ngStyle]="getStyle(numberColor)">
                <path
                  d="M835.7,868.8c3.7,0,7,.5,10,1.6,3,1.1,5.6,2.6,7.8,4.6,2.2,2,3.8,4.3,5,7.1,1.2,2.8,1.8,5.9,1.8,9.3s-.4,5.6-1.3,8.1c-.9,2.5-2,4.9-3.5,7.1-1.4,2.3-3.1,4.5-5.1,6.6-1.9,2.1-4,4.3-6.1,6.5l-17.9,18.2c1.8-.5,3.5-.9,5.2-1.2,1.7-.3,3.3-.4,4.8-.4h20.3c1.5,0,2.6.4,3.5,1.2s1.3,1.9,1.3,3.3v8.1h-54.4v-4.5c0-.9.2-1.9.6-2.8.4-1,1-1.9,1.8-2.7l24.1-24.1c2-2,3.8-4,5.4-5.9,1.6-1.9,2.9-3.7,4-5.5,1.1-1.8,1.9-3.7,2.5-5.6.6-1.9.8-3.9.8-5.9s-.3-3.6-.8-5c-.5-1.4-1.3-2.7-2.4-3.6-1-1-2.2-1.7-3.6-2.2s-3-.7-4.7-.7c-3.3,0-5.9.8-8,2.5-2.1,1.6-3.6,3.9-4.4,6.6-.4,1.4-1,2.4-1.8,3-.8.6-1.8.9-3.1.9s-1.2,0-1.8-.2l-7.1-1.3c.5-3.8,1.6-7.1,3.2-10s3.5-5.3,5.9-7.2,5.1-3.4,8.1-4.3c3.1-1,6.3-1.5,9.8-1.5Z"
                />
              </g>
            </g>
          </g>
          <g>
            <circle class="cls-11" cx="1341.5" cy="911.4" r="87.9" [ngStyle]="getStyle(primaryColor)" />
            <g class="cls-8">
              <g class="cls-8" [ngStyle]="getStyle(numberColor)">
                <path
                  d="M1340.8,868.8c3.7,0,7,.5,9.9,1.6,2.9,1,5.5,2.5,7.5,4.3s3.7,4,4.8,6.5c1.1,2.5,1.7,5.2,1.7,8.1s-.3,4.7-.8,6.7c-.6,1.9-1.4,3.6-2.5,5-1.1,1.4-2.4,2.6-3.9,3.6s-3.3,1.8-5.3,2.5c4.7,1.5,8.3,3.8,10.6,6.8,2.3,3.1,3.5,6.9,3.5,11.6s-.7,7.4-2.2,10.5-3.4,5.6-5.9,7.6c-2.5,2.1-5.4,3.6-8.6,4.7-3.3,1.1-6.7,1.6-10.4,1.6s-7.5-.5-10.4-1.4-5.5-2.3-7.7-4.1c-2.2-1.8-4.1-4-5.6-6.6s-2.8-5.6-3.9-9l6-2.5c1-.4,2.1-.7,3.1-.7s1.8.2,2.5.6c.7.4,1.3,1,1.7,1.8.7,1.3,1.4,2.5,2.2,3.8.8,1.2,1.7,2.3,2.8,3.3,1.1,1,2.4,1.8,3.9,2.4s3.2.9,5.3.9,4.3-.4,6-1.1c1.7-.7,3.2-1.7,4.3-2.9,1.2-1.2,2-2.5,2.6-4,.6-1.5.8-3,.8-4.5s-.2-3.6-.6-5.2c-.4-1.6-1.2-2.9-2.5-4-1.3-1.1-3.1-2-5.5-2.6s-5.6-.9-9.6-.9v-9.7c3.3,0,6.1-.3,8.3-.9,2.2-.6,3.9-1.4,5.2-2.4,1.3-1,2.2-2.3,2.7-3.8s.8-3.1.8-4.8c0-3.8-1-6.6-3.1-8.5s-4.8-2.9-8.4-2.9-5.9.8-8,2.5c-2.1,1.7-3.6,3.9-4.4,6.5-.4,1.4-1,2.4-1.8,3-.8.6-1.8.9-3,.9s-1.2,0-1.9-.2l-7.1-1.2c.5-3.8,1.6-7.1,3.2-10,1.6-2.9,3.5-5.3,5.9-7.2,2.4-1.9,5.1-3.4,8.1-4.3,3-1,6.3-1.5,9.8-1.5Z"
                />
              </g>
            </g>
          </g>
          <path
            class="cls-10"
            d="M1509.5,147.3v586.5c0,19.7-16,35.7-35.7,35.7h-264.6c-19.7,0-35.7-16-35.7-35.7V147.3c0-19.7,16-35.7,35.7-35.7h264.6c19.7,0,35.7,16,35.7,35.7h0Z"
          />
          <rect class="cls-13" x="1183.5" y="121.6" width="316" height="637.9" rx="25.7" ry="25.7" />
          <path
            class="cls-7"
            d="M1224.3,182.1h127.2c3.9,0,7,3.1,7,7h0c0,3.9-3.1,7-7,7h-127.2c-3.9,0-7-3.1-7-7h0c0-3.9,3.1-7,7-7Z"
          />
          <path
            class="cls-7"
            d="M1221.3,210h189.7c2.2,0,4,1.8,4,4h0c0,2.2-1.8,4-4,4h-189.7c-2.2,0-4-1.8-4-4h0c0-2.2,1.8-4,4-4Z"
          />
          <path
            class="cls-7"
            d="M1221.3,224.9h189.7c2.2,0,4,1.8,4,4h0c0,2.2-1.8,4-4,4h-189.7c-2.2,0-4-1.8-4-4h0c0-2.2,1.8-4,4-4Z"
          />
          <path
            class="cls-7"
            d="M1221.3,280.8h65.7c2.2,0,4,1.8,4,4h0c0,2.2-1.8,4-4,4h-65.7c-2.2,0-4-1.8-4-4h0c0-2.2,1.8-4,4-4Z"
          />
          <path
            class="cls-7"
            d="M1301.6,280.8h93.1c2.2,0,4,1.8,4,4h0c0,2.2-1.8,4-4,4h-93.1c-2.2,0-4-1.8-4-4h0c0-2.2,1.8-4,4-4Z"
          />
          <path
            class="cls-7"
            d="M1221.3,357.5h177c2.2,0,4,1.8,4,4h0c0,2.2-1.8,4-4,4h-177c-2.2,0-4-1.8-4-4h0c0-2.2,1.8-4,4-4Z"
          />
          <rect class="cls-7" x="1217.3" y="429.4" width="134.1" height="8" rx="3.4" ry="3.4" />
          <path
            class="cls-10"
            d="M976.2,113.6h-264.6c-19.7,0-35.7,16-35.7,35.7v586.5c0,19.7,16,35.7,35.7,35.7h264.6c19.7,0,35.7-16,35.7-35.7V149.3c0-19.7-16-35.7-35.7-35.7h0ZM1001.9,735.8c0,14.2-11.5,25.7-25.7,25.7h-264.6c-14.2,0-25.7-11.5-25.7-25.7V149.3c0-14.2,11.5-25.7,25.7-25.7h264.6c14.2,0,25.7,11.5,25.7,25.7v586.5h0Z"
          />
          <path
            class="cls-9"
            d="M976.2,123.6h-264.6c-14.2,0-25.7,11.5-25.7,25.7v586.5c0,14.2,11.5,25.7,25.7,25.7h264.6c14.2,0,25.7-11.5,25.7-25.7V149.3c0-14.2-11.5-25.7-25.7-25.7h0ZM959.1,571.6h-229.8v-229.8h229.8v229.8Z"
          />
          <g>
            <path class="cls-3" d="M959.1,394.8v-42.2c0-6-4.9-10.9-10.9-10.9h-38" />
            <path class="cls-3" d="M783.6,341.7h-43.5c-6,0-10.9,4.9-10.9,10.9v42.2" />
            <path class="cls-3" d="M910.2,571.6h38c6,0,10.9-4.9,10.9-10.9v-39.4" />
            <path class="cls-3" d="M729.2,521.3v39.4c0,6,4.9,10.9,10.9,10.9h43.5" />
          </g>
          <g>
            <line class="cls-2" x1="941.6" y1="157.6" x2="966.1" y2="182.1" />
            <line class="cls-2" x1="966.1" y1="157.6" x2="941.6" y2="182.1" />
          </g>
          <path class="cls-1" d="M1169.5,437.4h24v24h-24v-24Z" />
          <path
            class="cls-10"
            d="M1433,429.7c2.3,4.5,5.9,8.1,10.4,10.4l3.5-3.5c.4-.4,1.1-.6,1.6-.4,1.8.6,3.7.9,5.6.9s1.6.7,1.6,1.6v5.5c0,.9-.7,1.6-1.6,1.6-14.8,0-26.8-12-26.8-26.8s.7-1.6,1.6-1.6h5.5c.9,0,1.6.7,1.6,1.6,0,2,.3,3.9.9,5.6.2.6,0,1.2-.4,1.6l-3.5,3.5h0Z"
          />
          <path
            class="cls-10"
            d="M1441.5,284c3.5,0,6.3-2.8,6.3-6.3s-2.8-6.3-6.3-6.3-6.3,2.8-6.3,6.3,2.8,6.3,6.3,6.3ZM1441.5,287.2c-4.2,0-12.6,2.1-12.6,6.3v3.2h25.2v-3.2c0-4.2-8.4-6.3-12.6-6.3Z"
          />
          <path class="cls-1" d="M1169.5,437.4h24v24h-24v-24Z" />
          <path
            class="cls-10"
            d="M1454.1,344.9h-25.2c-1.7,0-3.1,1.4-3.1,3.2v18.9c0,1.7,1.4,3.2,3.1,3.2h25.2c1.7,0,3.2-1.4,3.2-3.2v-18.9c0-1.7-1.4-3.2-3.2-3.2ZM1454.1,351.2l-12.6,7.9-12.6-7.9v-3.2l12.6,7.9,12.6-7.9v3.2Z"
          />
          <path class="cls-1" d="M1169.5,437.4h24v24h-24v-24Z" />
          <path class="cls-1" d="M1329.5,552.5h24v24h-24v-24Z" />
          <path
            class="cls-12"
            d="M1341.5,517.9c-39.2,0-70.9,31.8-70.9,70.9s31.8,70.9,70.9,70.9,70.9-31.8,70.9-70.9-31.8-70.9-70.9-70.9ZM1327.3,624.3l-35.5-35.5,10-10,25.5,25.4,53.8-53.8,10,10.1-63.8,63.8Z"
            [ngStyle]="getStyle(successColor)"
          />
          <line class="cls-4" x1="1217.3" y1="299.8" x2="1415.1" y2="299.8" />
          <line class="cls-4" x1="1217.3" y1="373.6" x2="1415.1" y2="373.6" />
          <line class="cls-4" x1="1217.3" y1="447.4" x2="1415.1" y2="447.4" />
        </g>
      </g>
    </g>
  </g>
</svg>
